import {LabApi, Prompt, PromptResult, PromptTemplate} from "@betrue/shared/interfaces";
import {useState} from "react";
import {gql, useLazyQuery} from "@apollo/client";
import {useResult} from "./results";

export const PROMPT_RESULT_FIELDS = gql`
  fragment PromptResult on PromptResultModel{
    prompt
    userId
    creationDate
    promptTemplateLabel
    promptTemplateId
    inputWeight
    file {
      filename
      id
      mimetype
    }
    inputImage {
      id
      filename
      mimetype
    }
  }
`;

export const PROMPT_STYLE_FIELDS = gql`
  fragment PromptStyle on PromptTemplateModel{
    id
    logo
    weight
    label
    negativePrompt
    promptTemplate

  }
`;
const CREATE_LOG = gql`
  ${PROMPT_RESULT_FIELDS}
  query createLogo($prompt: PromptInput! ) {
    createLogo(prompt: $prompt) {
      ...PromptResult
    }
  }
`

const PROMPT_STYLE_LIST = gql`
  ${PROMPT_STYLE_FIELDS}
  query {
    promptStyles {
      ...PromptStyle
    }
  }
`
const PROMPTS_USER_LIST = gql`
  ${PROMPT_RESULT_FIELDS}
  query findUserPrompts($userId:String!) {
    findUserPrompts(userId:$userId) {
      ...PromptResult
    }
  }
`


export const usePrompt = <T = Prompt>(): [PromptResult | Error, PromptTemplate[],PromptResult[], LabApi] => {
  const [result, setResult] = useState<PromptResult | Error>();
  const [promptTemplates, setPromptTemplates] = useState<PromptTemplate[]>();
  const [userPrompts, setUserPrompts] = useState<PromptResult[]>();

  const findUserPrompts = useResult(useLazyQuery(PROMPTS_USER_LIST, {fetchPolicy:"network-only"}), setUserPrompts)

  const createLogo = useResult(useLazyQuery(CREATE_LOG, {fetchPolicy:"network-only"}), setResult)
  const getPromptStyles = useResult(useLazyQuery(PROMPT_STYLE_LIST, {}), setPromptTemplates)

  return [
    result,
    promptTemplates,
    userPrompts,
    {findUserPrompts(userId: string) {
        findUserPrompts({
          variables: {
            userId: userId
          }
        })
      }
      ,
    getPromptStyles() {
        getPromptStyles()
      }
      ,
      createLogo(prompt: Prompt) {
        createLogo({
          variables: {
            prompt: prompt
          }
        })
      }
    }]
}
